/**
 * The contract of GET /v1/net-metering/estimation on capi (#6324): the averages themselves, in one
 * answer. Snake case, because that is what the API speaks. The limits are echoed so the modal
 * renders the bounds the server enforces.
 */
export type EstimateResult = {
  electricity_usage_by_persons: Record<string, number>
  gas_usage_by_persons: Record<string, number>
  generation_per_panel: number
  limits: {
    persons: { min: number; max: number }
    solar_panels: { min: number; max: number }
  }
}

/**
 * The household sizes the modal offers. The design shows five tiles; capi's tables run to six, so
 * the design is the narrower of the two and wins.
 */
export const ESTIMATE_PERSONS = [1, 2, 3, 4, 5]

/** What the modal shows and hands to the input step. */
export type Estimate = {
  electricity: number
  generation: number
  gas: number
}
